<div *transloco="let t; read: 'bpView'" class="px-2 flex flex-col gap-2">
    <form [formGroup]="form">
        <formly-form [model]="componentModel" [fields]="fields()" [form]="form"></formly-form>
    </form>
</div>
